module.exports = __webpack_public_path__ + "img/16.f9a1ccfc.png";